import React from "react";
import {Alert, Button, Col, Container, Row} from "reactstrap";
import {inject, observer} from "mobx-react";
import IngredientsHeader from "./IngredientsHeader";
import Ingredients from "./Ingredients";
import Steps from "../editor/Steps";
import {withRouter} from "react-router-dom";
import IngredientsModal from "../ingredients/IngredientsModal";
import autobind from "autobind-decorator";

@withRouter
@inject("recipeStore")
@observer
class DetailsTab extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			showModal: false
		};
	}

	@autobind
	toggleModal() {
		this.setState({ showModal: !this.state.showModal });
	}

	@autobind
	getMissingFields(recipe) {
		const fields = [];
		if ((recipe.ingredientLines || []).filter(l => l.amount && l.unit && l.ingredient).length === 0) {
			fields.push({ id: "ingredients", label: "Ingredienser (mengde, enhet og ingrediens må fylles)" });
		}
		if ((recipe.steps || []).filter(s => s.instruction && s.instruction.trim() !== "").length === 0) {
			fields.push({ id: "steps", label: "Fremgangsmåte (minst ett steg)" });
		}
		return fields;
	}

	@autobind
	focusField(id) {
		const el = document.getElementById(id);
		if (el && typeof el.scrollIntoView === 'function') {
			el.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	}

	render() {
		const { recipeStore } = this.props;
		const recipe = recipeStore.currentRecipe;
		const { showModal } = this.state;
		const missingFields = this.getMissingFields(recipe);

		return (
			<Container className="mt-4">
				<h3><span className="content-title">Ingredienser og forklaring</span> | {recipe.displayName}</h3>
				{missingFields.length > 0 &&
					<Alert color="danger" className="mb-3">
						<strong>Du mangler følgende:</strong>
						<ul className="mb-0 mt-2">
							{missingFields.map(f =>
								<li key={f.id}>
									<button type="button" onClick={() => this.focusField(f.id)} className="btn btn-link p-0 align-baseline">{f.label}</button>
								</li>
							)}
						</ul>
					</Alert>
				}
				<Row>
					<Col className="col-sm-12">
						<h5>Ingredienser</h5>
						<p className="small">Legg til overskrift ved å bruke hurtigkommandoen <kbd>Ctrl + H</kbd> når du står på første element som skal være under overskriften. Hold <kbd>shift</kbd> for å se ingredienser som ikke er i bruk lengre.</p>
						<IngredientsHeader />
						<Ingredients />
						<Button color="primary" onClick={this.toggleModal}>Opprett manglende ingrediens</Button>
						<IngredientsModal isOpen={showModal} toggle={this.toggleModal} />
						<h5 className="mt-4">Fremgangsmåte</h5>
						<p className="small">Legg til overskrift ved å bruke hurtigkommandoen <kbd>Ctrl + H</kbd> når du står på første element som skal være overskriften. Legg til lenker eller redigere markert tekst i tipsfeltet ved å taste <kbd>Ctrl + K</kbd> eller <kbd>Ctrl + klikk</kbd></p>
						<Steps />
					</Col>
				</Row>
			</Container>
		);
	}

}

DetailsTab.propTypes = {

};


export default DetailsTab;